import { ElementType, PropsWithChildren } from "react";

import { Interpolation, Theme } from "@emotion/react";
import Link from "@mui/material/Link";

export interface FooterLinkProps extends PropsWithChildren {
  component: ElementType;
  dataTestId: string;
  href?: string;
  css?: Interpolation<Theme>;
  newTab?: boolean;
  onClick?: () => void;
}

export const FooterLink = ({
  component,
  dataTestId,
  href,
  css,
  newTab,
  onClick,
  children,
  ...rest
}: FooterLinkProps) => {
  return (
    <Link
      component={component}
      data-testid={dataTestId}
      css={css}
      onClick={() => onClick?.()}
      {...(href ? { href: href, target: newTab ? "_blank" : "_self" } : {})}
      {...(component === "button" ? { type: "button" } : {})}
      {...rest}
    >
      {children}
    </Link>
  );
};
